<template>
  <div class="editable-text-cell">
    <!-- 编辑按钮 -->
    <el-tooltip v-if="editable" :content="editTooltip" placement="top">
      <i class="el-icon-edit action-icon edit-icon" @click="handleEdit"></i>
    </el-tooltip>

    <!-- 文本内容 -->
    <span class="text-content">{{ displayText }}</span>

    <!-- 查看完整内容（文本超长且不可编辑时显示） -->
    <el-popover v-if="isOverflow && !editable" placement="top" width="320" trigger="click">
      <div class="full-text-box">
<!--        <div class="full-text-title">完整内容</div>-->
        <div class="full-text-content">{{ text }}</div>
      </div>
      <el-tooltip slot="reference" :content="moreTooltip" placement="top">
        <i class="action-icon view-icon" v-html="viewDetailIcon"></i>
      </el-tooltip>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "EditableTextCell",
  props: {
    // 是否可编辑
    editable: {
      type: Boolean,
      default: true
    },
    // 显示的文本
    text: {
      type: String,
      default: ""
    },
    // 最大显示长度
    maxLength: {
      type: Number,
      default: 10
    },
    // 编辑按钮提示
    editTooltip: {
      type: String,
      default: "编辑"
    },
    // 查看更多提示
    moreTooltip: {
      type: String,
      default: "查看更多"
    }
  },
  data(){
    return {
     viewDetailIcon:'<i style="color: #3f9dfe;margin-right: 3px" aria-label="图标: file-search" class="anticon anticon-file-search"><svg viewBox="64 64 896 896" data-icon="file-search" width="1.2em" height="1.2em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 0 0 0-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path></svg></i>'

    }
  },
  computed: {
    // 是否超出长度
    isOverflow() {
      return this.text && this.text.length > this.maxLength;
    },
    // 显示的文本（截断）
    displayText() {
      if (!this.text) return "";
      if (this.isOverflow) {
        return this.text.slice(0, this.maxLength) + "...";
      }
      return this.text;
    }
  },
  methods: {
    handleEdit() {
      this.$emit("edit", this.text);
    }
  }
};
</script>

<style scoped>
.editable-text-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.text-content {
  color: #606266;
  word-break: break-all;
}
.action-icon {
  cursor: pointer;
  font-size: 14px;
  padding: 2px;
  transition: all 0.2s;
}
.edit-icon {
  color: green;
}
.edit-icon:hover {
  color: #67b93f;
}
.view-icon {
  color: #409eff;
}
.view-icon:hover {
  color: #66b1ff;
}
/* 完整内容弹窗 */
.full-text-box {
  max-height: 240px;
  overflow-y: auto;
}
.full-text-title {
  font-weight: 500;
  color: #6a6a6b;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}
.full-text-content {
  line-height: 1.6;
  word-break: break-all;
  color: #606266;
}
</style>
